/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PricingModeInputDto = {
    /**
     * Session mode
     */
    mode: PricingModeInputDto.mode;
    /**
     * Single session price for this mode
     */
    single_session_price: number;
};
export namespace PricingModeInputDto {
    /**
     * Session mode
     */
    export enum mode {
        ONLINE = 'online',
        CLIENT_LOCATION = 'client_location',
        EXPERT_LOCATION = 'expert_location',
    }
}

